import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['option', 'radioButton'];

  connect() {
    this.initiatePrice();
  }

  initiatePrice() {
    const result = this.updatePrice();

    if (result === true) {
      return true;
    }
    this.optionTargets.forEach((_, index) => {
      if (index === 0) {
        this.optionTargets[index].classList.remove('hidden');
      }
    });
    return true;
  }

  updatePrice() {
    let result = false;

    this.radioButtonTargets.forEach((option, index) => {
      if (option.checked) {
        this.optionTargets[index].classList.remove('hidden');
        result = true;
      } else {
        this.optionTargets[index].classList.add('hidden');
      }
    });
    return result;
  }
}
